import { founder } from './content'
import { creators } from './creators'
import type { AttributionCode, Creator, SiteSettings } from '../core/types/site'

/**
 * Losse klantcodes (niet van een vaste cliënt). Codes zijn voor attributie, nooit voor korting.
 * Alleen een code die écht iets doet, noemt dat in `gift` (de saloncode: je huidplan wordt
 * bijgewerkt). Het reisformaat komt via de cadeaustaffel, niet via een code.
 */
export const codes: AttributionCode[] = [
  {
    code: 'SALON',
    label: `Salonklant van ${founder.firstName}`,
    gift: 'Je huidplan wordt persoonlijk bijgewerkt na je volgende behandeling',
  },
]

/** De salonkode, waarmee een afspraak aan een protocol gekoppeld wordt. */
export const SALON_CODE = 'SALON'

/**
 * Alle geldige codes uit gegeven instellingen: de losse codes plus die van elke vaste cliënt. Puur.
 * De code van een cliënt legt alleen vast via wie je kwam: geen cadeau (`gift` leeg).
 */
export const codesIn = (site: Pick<SiteSettings, 'codes'> & { creators: readonly Pick<Creator, 'code' | 'handle'>[] }): AttributionCode[] => [
  ...site.codes,
  ...site.creators.map((c) => ({
    code: c.code,
    label: `Via ${c.handle}`,
    gift: '',
  })),
]

/** Een code opzoeken (hoofdletters maken niet uit). Puur: de lijst komt mee (`codesIn(useSite())`). */
export const findCodeIn = (all: readonly AttributionCode[], input: string) =>
  all.find((c) => c.code.toLowerCase() === input.trim().toLowerCase()) ?? null

// Oude aanroepers: de gedeelde lijsten. Nieuwe code: `findCodeIn(codesIn(site), …)`.
export const allCodes = (): AttributionCode[] => codesIn({ codes, creators })
export const findCode = (input: string) => findCodeIn(allCodes(), input)
